import { useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";

const LogoutButton = ({ 
  logout, 
  onLogout, 
  variant = "ghost", 
  size = "sm", 
  showIcon = true, 
  showText = false,
  className = "" 
}) => {
  const [showConfirm, setShowConfirm] = useState(false);

  const handleLogout = async () => {
    if (logout) {
      await logout();
    }
    if (onLogout) {
      onLogout();
    }
    setShowConfirm(false);
  };

  return (
    <>
      <Button 
        variant={variant} 
        size={size} 
        onClick={() => setShowConfirm(true)}
        className={className}
        data-testid="logout-btn"
      >
        {showIcon && <LogOut className="w-4 h-4" />}
        {showText && <span className={showIcon ? "ml-2" : ""}>Logout</span>}
      </Button>

      <AlertDialog open={showConfirm} onOpenChange={setShowConfirm}>
        <AlertDialogContent className="max-w-sm">
          <AlertDialogHeader>
            <AlertDialogTitle>Sign out?</AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to sign out of your account?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction 
              onClick={handleLogout}
              className="bg-black hover:bg-gray-800"
            >
              Sign out
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default LogoutButton;
